import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getTarifs() {
  const data = await apiGet('helper/priceTarifs/');
  useHelperStore().setTarifs(data);
}
